<h4 class="">
  <p class="text-center">Users</p>
</h4>
<div class="row ui-toolbar">
  <div class="col-12 btn-toolbar">
    <button type="button" class="btn btn-success" (click)="addUser()">
      Toevoegen
    </button>
  </div>
</div>

<p-dataTable [value]="users" [rows]="10" [paginator]="true" [pageLinks]="5"
             scrollable="true" selectionMode="single" [(selection)]="selectedUser">
  <p-column field="name" header="Naam" [sortable]="true"></p-column>
  <p-column field="email" header="Email" [sortable]="true"></p-column>
</p-dataTable>



// WEBPACK FOOTER //
// ./src/app/pages/admin/users/admin.users.component.html